<template>
  <div class="personal">
    <!-- 左边 -->
    <div class="personal-left fx__bgcolor">
      <!-- Header  -->
      <div class="personal-left_header fx-fill-brand fx-color-white">
        <Icon type="ios-options" /> <span style="margin-left: 10px">个人设置</span>
      </div>
      <!-- body  -->
      <div class="personal-left_body">
        <div class="personal-left_item fx__item" :class="{ 'fx__item-selected': selectItem.key == item.key }" v-for="(item, index) in list" :key="index" @click="onselect(item)">
          <p style="font-size: 14px; margin-bottom: 3px; font-weight: bold">{{ item.title }}</p>
          <p>{{ item.describe }}</p>
        </div>
      </div>
    </div>
    <!-- 右边 -->
    <div class="personal-right">
      <component :is="selectItem.component"> </component>
    </div>
  </div>
</template>
<script>
import basicSetting from "./components/basicSetting"
import securitySetting from "./components/securitySetting"
import styleSetting from "./components/styleSetting"
export default {
  // components: {
  //   basicSetting,
  //   securitySetting,
  //   styleSetting,
  // },
  watch: {
    $route: {
      handler(to, from) {
        let _this = this
        if (to.name != "core-personalSetting") return
        if (to.params.key == "null") {
          return _this.$router.push({ name: "core-personalSetting", params: { key: this.list[0].key } })
        }
        let _selectedItem = this.list.find((k) => k.key == to.params.key)
        if (_selectedItem) {
          this.$set(this, "selectItem", _selectedItem)
        }
      },
      immediate:true
    },
    selectItem(val, oldval) {},
  },
  data() {
    let channelsDict = this.$app.Cfg.notify && this.$app.Cfg.notify.channelsDict
    let list = [
      {
        key: "basicSetting",
        title: "基本设置",
        describe: "个人账户信息设置",
        component: basicSetting,
      },
      {
        key: "securitySetting",
        title: "安全设置",
        describe: "修改密码",
        component: securitySetting,
      },
      {
        key: "styleSetting",
        title: "风格设置",
        describe: "设置布局、主题、自定义菜单等设置",
        component: styleSetting,
      },
    ]

    if (!lodash.isEmpty(channelsDict)) {
      list.push({
        key: "channelSetting",
        title: "消息订阅",
        describe: "设置个人消息订阅",
        component: "core-notify-subscribe",
      })
    }

    return {
      list,
      selectItem: {},
    }
  },

  mounted() {
    // console.log();
    let _this = this
    fxImport("./web/config/core/personalSetting/navleft.config.js")
      .then((res) => {
        if (res.getListItems) {
          return res.getListItems(_this.list)
        }
      })
      .then((res) => {
        if (res) _this.$set(_this, "list", res)
      })
      .finally(() => {
        _this.load()
      })
  },
  computed: {},
  methods: {
    load() {
      let _this = this
      // _this.$router.push({ name: "core-personalSetting", params: { key: _this.list[0].key } })
    },
    onselect(item) {
      let _this = this
      _this.$router.push({ name: "core-personalSetting", params: { key: item.key } })
    },
  },
}
</script>
<style lang="scss" scoped>
.personal {
  display: flex;
  height: 100%;
  padding: 16px;
  .personal-left {
    width: 350px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    // box-shadow: 0px 2px 3px 0px rgba(54, 54, 54, 0.12);
    .personal-left_header {
      font-size: 16px;
      height: 40px;
      width: 100%;
      padding: 0 16px;
      line-height: 40px;
      margin-bottom: 5px;
    }
    .personal-left_body {
      width: 100%;
      flex: 1;
      overflow-y: auto;
      .personal-left_item {
        height: 60px;
        padding: 10px 16px;
        cursor: pointer;
      }
    }
  }
  .personal-right {
    margin-left: 16px;
    flex: 1;
    height: auto;
    overflow-y: auto;
  }
}
.uiconfig_body {
}
.uiconfig_icon {
  position: absolute;
  top: -22px;
  /* right: 0px; */
  left: 60px;
  cursor: pointer;
}
@media screen and (min-width: 995px) and (max-width: 1600px) {
  .uiconfig_item {
    .ivu-card {
      .ivu-card-body {
        .uiconfig_body {
          height: 150px !important;
          background-position: center center !important;
        }
      }
    }
  }
}
@media screen and (min-width: 586px) and (max-width: 800px) {
  .uiconfig_item {
    .ivu-card {
      .ivu-card-body {
        .uiconfig_body {
          height: 150px !important;
          background-position: center center !important;
        }
      }
    }
  }
}
</style>
